import { render, staticRenderFns } from "./butterfly-vue.vue?vue&type=template&id=886946f8&"
import script from "./butterfly-vue.vue?vue&type=script&lang=js&"
export * from "./butterfly-vue.vue?vue&type=script&lang=js&"
import style0 from "./butterfly-vue.vue?vue&type=style&index=0&id=886946f8&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports